import { mapEnumToOptions } from '@abp/ng.core';

export enum PaymentStatus {
  UnPaid = 0,
  Partial = 1,
  Paid = 2,
}

export const paymentStatusOptions = mapEnumToOptions(PaymentStatus);
